import { ShoppingBag } from 'lucide-react';
import type { PluginDefinition } from '../types';
import { SacolinhasConfigComponent } from './ConfigComponent';
import { SacolinhasPage } from './PageComponent';
import type { SacolinhasConfig } from './types';

export const sacolinhasPlugin: PluginDefinition<SacolinhasConfig> = {
  slug: 'sacolinhas',
  icon: ShoppingBag,
  navLabel: 'Sacolinhas',
  navIcon: ShoppingBag,
  navPath: '/sacolinhas',
  defaultConfig: {
    deadline_enabled: false,
    deadline_days: 15,
  },
  ConfigComponent: SacolinhasConfigComponent,
  PageComponent: SacolinhasPage,
};

export { SacolinhasPage };
export type { SacolinhasConfig };
